<template>
  <div>
    <!-- 转库单明细 -->
    <el-dialog :title="$t('message.transferOrderDetails')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1436px" center>
      <div class="content">

        <div class="table">
          <ol>
            <li class="flex05">No</li>
            <!--库位  -->
            <li>{{ $t("message.location") }}</li>
            <!-- 订单编号 -->
            <li>{{ $t("message.orderNumber") }}</li>
            <!-- 番号 -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!-- 图片 -->
            <li class="flex05">
              {{ $t("message.pic") }}
            </li>
            <!-- 商品属性 -->
            <li>
              {{ $t("message.commodityAttribute") }}
            </li>
            <!-- 交易号/物流号 -->
            <li>
              {{ $t("message.transactionNumberLogisticsNumber") }}
            </li>

            <!-- 单番操作备注 -->
            <li>
              {{ $t("message.operationProductRemark") }}
            </li>
            <!-- 转库数量 -->
            <li class="flex05">
              {{ $t("message.transferOrderQuantity") }}
            </li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <li class="flex05">{{ index + 1 }}</li>
            <!--库位  -->
            <li>
              <p>{{ item.grid_number.split("】-")[0] }}】-</p>
              <p style="color: #fa5058">
                {{ item.grid_number.split("】-")[1] }}
              </p>
            </li>
            <!-- 订单编号 -->
            <li>
              <div>
                <router-link :to="'/orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">{{
                  item.order_sn }}</router-link>
                <p style="margin-top: 10px;">{{ item.user.realname }}</p>
              </div>

            </li>
            <!-- 番号 -->
            <li class="flex05">{{ item.sorting }}</li>
            <!-- 图片 -->
            <li class="flex05">
              <el-popover placement="right" width="300" trigger="hover">
                <el-image :src="item.pic" style="width: 300px; height: 300px;" />
                <a :href="item.link.goods_url" target="_blank" rel="noopener" slot="reference">
                  <el-image :src="item.pic" fit="fill" style="width: 60px; height: 60px;" />
                </a>
              </el-popover>
            </li>
            <!-- 商品属性 -->
            <li>
              <div class="template">
                <p v-for="(attr, attrIndex) in item.detail_y" :key="attrIndex">
                  {{ attr.key }}:{{ attr.value }}
                </p>
              </div>
            </li>
            <!-- 交易号/物流号 -->
            <li>
              <div class="template">
                <P>JY:{{ item.purchase_no }}</P>
                <p v-for="(express_no, express_noIndex) in item.express_no" :key="express_noIndex">
                  WL: {{ express_no }}
                </p>
              </div>
            </li>

            <!-- 单番操作备注 -->
            <li>
              {{ item.remark }}
            </li>
            <!-- 转库数量 -->
            <li class="flex05">
              {{ item.num }}
            </li>
          </ul>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      list: [],
      dialogVisible: false,
    };
  },
  methods: {

  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;


  .table {


    ol {
      display: flex;
      height: 50px;
      background: #EDEFF4;
    }

    ul {
      display: flex;
      padding: 0;


      li {
        padding: 30px 0;
      }
    }

    li {
      .template {
        width: 100%;
        text-align: left;
      }
    }

    .flex15 {
      flex: 1.5;
    }

    .flex05 {
      flex: 0.5;
    }
  }


}
</style>